module.exports = __webpack_public_path__ + "static/media/FD-bg.d2e13108.jpg";